import SecurityTool from "./SecurityTool.js";

export default SecurityTool;